import { RouteRecordRaw } from 'vue-router';
import { AppCoreEnums } from '@/core/shared/enums';
import { AppPermissions } from '@/shared/permissions';
import { IRouteMeta, ResolveParams } from '@/core/models/routing';

const ROUTE_CHAT = 'chat';
const ROUTE_CHAT_ROOT = 'chat-root';
const ROUTE_CHAT_ACTIVE = 'active-chat';
const ROUTE_CHAT_PROJECT_ACTIVE = 'active-prooject-chat';
const ROUTE_CHAT_PROJECT = 'chat-project';
const ROUTE_CHAT_DETAILS = 'chat-details';
const ROUTE_CHAT_OVERVIEW = 'chat-overview';

const chatRoutes: RouteRecordRaw = {
  name: ROUTE_CHAT_ROOT,
  path: 'chat',
  component: () => import('src/pages/chat/chat-root-page.vue'),
  meta: <IRouteMeta>{
    resolve: async (params) => {
      const { useChatStore } = await import('@/stores');
      const chatStore = useChatStore();
      const { default: useWorkingFolders } = await import('@/composables/chat/use-working-folders');
      const { loadWorkingFoldersFromPreferences } = useWorkingFolders();

      chatStore.resetHistoryChatsPagination();
      await Promise.all([
        chatStore.loadChatbots(params, true, true),
        chatStore.getChatProjects(),
        chatStore.loadUserChats(params),
        chatStore.loadUserActiveChatbot(),
      ]);

      loadWorkingFoldersFromPreferences();
    },
    permissions: {
      readPermission: AppPermissions.ChatRead,
      writePermission: AppPermissions.ChatWrite,
      deletePermission: AppPermissions.ChatDelete,
    },
    containerType: AppCoreEnums.ContainerType.EmptyContainer,
  },
  redirect: { name: ROUTE_CHAT },
  children: [
    {
      name: ROUTE_CHAT,
      path: '',
      component: () => import('src/pages/chat/chat-page.vue'),
      meta: <IRouteMeta>{
        resolve: (params) => Promise.resolve(),
        containerType: AppCoreEnums.ContainerType.EmptyContainer,
      },
      children: [
        {
          name: ROUTE_CHAT_ACTIVE,
          path: ':id',
          component: () => import('src/pages/chat/chat-messages-page.vue'),
          meta: <IRouteMeta>{
            containerType: AppCoreEnums.ContainerType.EmptyContainer,
            resolve: async (params: ResolveParams) => {
              const { useChatStore } = await import('@/stores');
              return useChatStore().loadChatMessages(params);
            },
          },
        },
      ],
    },
    {
      name: ROUTE_CHAT_PROJECT,
      path: 'project/:id',
      component: () => import('src/pages/chat/chat-project-page.vue'),
      meta: <IRouteMeta>{
        containerType: AppCoreEnums.ContainerType.EmptyContainer,
        resolve: async (params: ResolveParams) => {
          const { useChatStore } = await import('@/stores');
          const chatStore = useChatStore();
          chatStore.resetProjectHistoryChats();
          return Promise.all([chatStore.getChatProjectIndex(params), chatStore.loadProjectChats(params)]);
        },
      },
      children: [
        {
          name: ROUTE_CHAT_PROJECT_ACTIVE,
          path: ':id2',
          component: () => import('src/pages/chat/project-chat-messages-page.vue'),
          meta: <IRouteMeta>{
            containerType: AppCoreEnums.ContainerType.EmptyContainer,
            resolve: async (params: ResolveParams) => {
              const { useChatStore } = await import('@/stores');
              return useChatStore().loadChatMessages(params);
            },
          },
        },
      ],
    },
  ],
};

export {
  chatRoutes,
  ROUTE_CHAT,
  ROUTE_CHAT_ROOT,
  ROUTE_CHAT_DETAILS,
  ROUTE_CHAT_OVERVIEW,
  ROUTE_CHAT_ACTIVE,
  ROUTE_CHAT_PROJECT,
  ROUTE_CHAT_PROJECT_ACTIVE,
};
